import React from 'react';

type StatusType =
  | 'draft' | 'sent' | 'due' | 'overdue' | 'paid' | 'reconciled' |'active' | 'complete' | 'cancelled'
  | 'pending'| 'in-progress' | 'delivered' |'acknowledged'| 'received' | 'closed' | 'confirmed' | 'fulfilled' | 'invoiced' |'due-soon';

interface StatusBadgeProps {
  status: StatusType | string;
  pulse?: boolean;
}

const statusConfig: Record<string, { label: string; bg: string; text: string; dot: string }> = {
  draft:        { label: 'Draft',        bg: 'var(--slate-light)', text: 'var(--slate)', dot: 'var(--slate)' },
  sent:         { label: 'Sent',         bg: '#EEF4FF', text: '#3B5BDB', dot: '#3B5BDB' },
  due:          { label: 'Due',          bg: 'var(--amber-light)', text: '#B87A1A', dot: 'var(--amber)' },
  'due-soon':   { label: 'Due soon',     bg: 'var(--amber-light)', text: '#B87A1A', dot: 'var(--amber)' },
  overdue:      { label: 'Overdue',      bg: '#FEE2E2', text: '#B91C1C', dot: '#EF4444' },
  paid:         { label: 'Paid',         bg: 'var(--teal-light)', text: 'var(--accent)', dot: 'var(--accent)' },
  reconciled:   { label: 'Reconciled',   bg: 'var(--teal-light)', text: 'var(--accent)', dot: 'var(--accent)' },
  active:       { label: 'Active',       bg: 'var(--teal-light)', text: 'var(--accent)', dot: 'var(--accent)' },
  complete:     { label: 'Complete',     bg: '#EEF4FF', text: '#3B5BDB', dot: '#3B5BDB' },
  cancelled:    { label: 'Cancelled',    bg: '#F1F3F5', text: '#868E96', dot: '#868E96' },
  pending:      { label: 'Pending',      bg: 'var(--slate-light)', text: 'var(--slate)', dot: 'var(--slate)' },
  'in-progress':{ label: 'In progress',  bg: '#FFF3BF', text: '#9C6700', dot: '#F59F00' },
  delivered:    { label: 'Delivered',    bg: 'var(--teal-light)', text: 'var(--accent)', dot: 'var(--accent)' },
  acknowledged: { label: 'Acknowledged', bg: '#EEF4FF', text: '#3B5BDB', dot: '#3B5BDB' },
  received:     { label: 'Received',     bg: 'var(--teal-light)', text: 'var(--accent)', dot: 'var(--accent)' },
  closed:       { label: 'Closed',       bg: '#F1F3F5', text: '#868E96', dot: '#868E96' },
  confirmed:    { label: 'Confirmed',    bg: 'var(--teal-light)', text: 'var(--accent)', dot: 'var(--accent)' },
  fulfilled:    { label: 'Fulfilled',    bg: '#EEF4FF', text: '#3B5BDB', dot: '#3B5BDB' },
  invoiced:     { label: 'Invoiced',     bg: '#EEF4FF', text: '#3B5BDB', dot: '#3B5BDB' },
};

export default function StatusBadge({ status, pulse = false }: StatusBadgeProps) {
  const key = status.toLowerCase().replace(' ', '-');
  const config = statusConfig[key] || { label: status, bg: 'var(--muted)', text: 'var(--slate)', dot: 'var(--slate)' };

  return (
    <span
      className={`status-badge${pulse ? ' pulse-amber' : ''}`}
      style={{ backgroundColor: config.bg, color: config.text }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full flex-shrink-0"
        style={{ backgroundColor: config.dot }}
      />
      {config.label}
    </span>
  );
}